<div id="invalidated" role="alert" aria-live="assertive">
  <mat-icon aria-hidden="true">link_off</mat-icon>
  <p class="title">{{ 'linkInvalidatedTitle' | translate }}</p>
  <p class="description">{{ 'linkInvalidatedDescription' | translate }}</p>
  <p class="company-name" *ngIf="company!=null && company.trade_name!=null">{{ company.trade_name }}</p>
</div>
